/**
 * Inloggen met een link per mail — voor helden en voor het beheer (SPEC §9.2).
 */

import { useState, type FormEvent } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api, type OmgevingInfo } from '../api';
import { Knop, Kroon, Melding, Veld, useTitel } from '../componenten/basis';
import { Pagina } from '../componenten/Schil';

export function Inloggen({ omgeving, soort = 'held' }: { omgeving: OmgevingInfo; soort?: 'held' | 'beheer' }) {
  useTitel('Inloggen');
  const [params] = useSearchParams();
  return (
    <Pagina smal>
      <div className="verschijn py-16">
        <Inlogformulier soort={soort} omgeving={omgeving} verlopen={params.get('fout') === 'verlopen'} />
      </div>
    </Pagina>
  );
}

export function Inlogformulier({ soort, omgeving, verlopen = false }: { soort: 'held' | 'beheer'; omgeving: OmgevingInfo; verlopen?: boolean }) {
  const [email, zetEmail] = useState('');
  const [bezig, zetBezig] = useState(false);
  const [melding, zetMelding] = useState<string | null>(null);

  async function verstuur(e: FormEvent) {
    e.preventDefault();
    zetBezig(true);
    try {
      const uit = await api.stuur<{ melding: string }>('/api/inloglink', { email, soort });
      zetMelding(uit.melding);
    } catch (f) {
      zetMelding((f as Error).message);
    } finally {
      zetBezig(false);
    }
  }

  return (
    <div className="kaart mx-auto max-w-md p-8">
      <Kroon className="h-9 w-9 text-goud-400" />
      <h1 className="mt-4 text-3xl">{soort === 'beheer' ? 'Inloggen in het beheer' : 'Naar je eigen pagina'}</h1>
      <p className="mt-2 text-sm text-inkt-zacht">
        Geen wachtwoord: vul je e-mailadres in en je krijgt een link die één keer werkt.
      </p>
      {verlopen && <div className="mt-4"><Melding soort="fout">Deze link is verlopen of al gebruikt. Vraag een nieuwe aan.</Melding></div>}
      {melding ? (
        <div className="mt-6">
          <Melding soort="goed">{melding}</Melding>
          {omgeving.testmodus && <p className="mt-3 text-xs text-test">Testmodus: de mail gaat naar het omleidingsadres.</p>}
        </div>
      ) : (
        <form onSubmit={verstuur} className="mt-6 space-y-4">
          <Veld etiket="E-mailadres">
            <input className="veld" type="email" required autoComplete="email" value={email} onChange={(e) => zetEmail(e.target.value)} />
          </Veld>
          <Knop type="submit" bezig={bezig}>
            Stuur mij een inloglink
          </Knop>
        </form>
      )}
    </div>
  );
}
